import {FormFieldProps} from '..'

const name: FormFieldProps = {
    name: 'name',
    type: 'text',
    label: 'Team Name',
    required: true,
    help: 'How this application should refer to your team.',
  }

const theme = {
    name: 'theme',
    primary: {
      name: 'theme.primary',
      type: 'color',
      label: 'Primary Color',
      required: true,
      help: 'The color for buttons, links, and highlighting.',
    } as FormFieldProps,
  }

export const UpdateTeamForm = {name, theme}
